//import {IonApp} from '@ionic/angular';
import { Injectable, NgZone, Optional, SkipSelf } from '@angular/core';
import { NavController, LoadingController, ModalController, ToastController, IonRouterOutlet, AlertController } from '@ionic/angular';
import { LaunchNavigator, LaunchNavigatorOptions } from '@awesome-cordova-plugins/launch-navigator/ngx';
import { Connection } from '../services/connection';
import { Places } from '../services/places';
import {DomSanitizer} from '@angular/platform-browser';
import { SplashScreen } from '@capacitor/splash-screen';
//import {TabsPage} from '../pages/tabs/tabs';

import { Vibration } from '@ionic-native/vibration/ngx';

import { Network } from '@ionic-native/network/ngx';
import { Location } from "@angular/common";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { Camera, CameraOptions } from '@ionic-native/camera/ngx';

import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { Storage } from '@ionic/storage-angular';

import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';

//import { Geolocation } from '@capacitor/geolocation';
//import { Geolocation } from '@ionic-native/geolocation';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';

import { RatingPage } from '../pages/rating/rating.page';

import { VetProfilePage } from '../pages/vet_profile/vet_profile.page';

import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';

import { Capacitor } from '@capacitor/core';



@Injectable()

export class SharedService {

    //LOCAL OBJECTS

    public platform: any;
    public platformName: any;
    public deviceToken: any;

    public tab1RootNavCtrl: any;
    public tab2RootNavCtrl: any;
    public tab3RootNavCtrl: any;
    public tab4RootNavCtrl: any;
    public tab5RootNavCtrl: any;

    public homeTabIcon = 'ios-home';
    public searchTabIcon = 'ios-search';
    public activityHubTabIcon = 'ios-chatboxes-outline';
    public profileTabIcon = 'ios-person';
    public createTabIcon = 'ios-add-circle';
    public settingsTabIcon = 'ios-more-outline';

    public selectedTabName = 'home';

    public currentUserId = null;
    public referringEntityId: string = '';
    public rememberToken = null;
    public latitudeActive;
    public longitudeActive;
    public connection: any;
    public places: any;
    public loader: any;

    public loggedIn: boolean;

    public refreshApp: boolean = false;

    public keyboardVisible = false;
    public keyboardHeight = 0;

    public showInAppNotification: boolean = false;
    public inAppNotificationText: string = '';

    public passwordResetToken = null;

    public canGoBack: boolean = false;
    public activeKeyboardListener: boolean = true;

    public appointmentsPastAppointmentSearchText: any;

    public setup = {
      env: 'remote',
      debug: false,
      version: '1.4.23',
      baseurl: {
        local: 'http://localhost:8000',
        remote: 'https://api.vetibility.com',
  	    dev: 'https://apidev.vetibility.com',
        device: 'http://192.168.4.95:8000'
      }
    };

    public applicationUpdateRequired: boolean = false;

    public pushData: any;
    public screenOrientation: any;
    public showActivityHubTabBadge: boolean = false;
    public showConversationHubBadge: boolean = false;
    public conversationHubBadgeCount: any;
    public activityHubTabBadgeCount: any;

    public conversations: any;

    public networkActive: boolean = true;

    public turnServerDetails: any;

    //GLOBAL OBJECTS

    public currentUser = {
      username: null,
      user_id: null,
      type_id: null, //1 = vet; 2 = client
      status_type_id: null,
      remember_token: null,
      device: {
        token: null,
        platform: null,
        version: null
      },
      profile: null,
      url_signature: null
    };

    public settings = {
      push_appointments: 1,
      clinic_clients_only: 0,
      vetibility_clinic_network: 0
    };

    public petResultStack: any = [];
    public apptResultStack: any = [];
    public pastApptResultStack: any = [];
    public triageQueueApptResultStack: any = [];

    public presets = {
      species: [],
      species_experience: [],
      canine_breeds: [],
      feline_breeds: [],
      breeds: [],
      canine_vaccines: [],
      feline_vaccines: [],
      vaccines: [],
      licensing_bodies: [],
      specializations: [],
      languages: [],
      peerjs_server: null
    };

    public canineVaccineStack = [
      'Rabies',
      'DA2PP',
      'Leptospirosis',
      'Bordetella',
      'Lyme Disease',
      'Canine Influenza'
    ];

    public felineVaccineStack = [
      'Rabies',
      'FVRCP',
      'FeLV'
    ];

    public speciesPresetStack = [
      'Canine',
      'Feline'
    ];

    public presentingComplaintStack: any = [];

    public pricing = {
      currency: null,
      fee: null,
      taxes: null,
      total: null
    };

    public apptResultStackOffset = 0;
    public apptResultStackLimit = 50;
    public triageQueueApptResultStackOffset = 0;
    public triageQueueApptResultStackLimit = 50;
    public pastApptResultStackOffset = 0;
    public pastApptResultStackLimit = 50;
    public petResultStackOffset = 0;
    public petResultStackLimit = 50;

    public showAppointmentBadge: boolean = false;
    public appointmentBadgeCount = 0;
    public foreground: boolean = true;

    public activeTab: any = null;

    public currentLocation: any = null;

    public payPalScriptLoaded: boolean = false;
    public payPalBaseURL = 'Ac57CbB7waOHvR9I_H_t_qToVW6DlL5HSNA-vpTc87QEo8Zu84_qjWv2P_oJSZDS2pa6tP0Ug8Yz440c';
    //SANDBOX: Ac57CbB7waOHvR9I_H_t_qToVW6DlL5HSNA-vpTc87QEo8Zu84_qjWv2P_oJSZDS2pa6tP0Ug8Yz440c
    //PRODUCTION: ASqFQM8VDd4BfCxjKH84LPppbJddx6ibQE4EtRIXKyHLNDnRJIcQypXqETqqgqs-IW5B-U8iKiYGIWqb

    public country_long_name: null;
    public country_short_name: null;

    public updateAppointmentStatus: boolean = false;

    constructor(public toastCtrl: ToastController,
      public vibration: Vibration,
      public network: Network,
      public zone: NgZone,
      public domSanitizer: DomSanitizer,
      public location: Location,
      public router: Router,
      public camera: Camera,
      public nativeStorage: NativeStorage,
      public storage: Storage,
      public navController: NavController,
      public loadingController: LoadingController,
      public alertController: AlertController,
      private inAppBrowser: InAppBrowser,
      private routerOutlet: IonRouterOutlet,
      private modalController: ModalController,
      private launchNavigator: LaunchNavigator,
      private callNumber: CallNumber,
      public geolocation: Geolocation,
      @Optional() @SkipSelf() sharedService?: SharedService
      ) {

      if(sharedService) {
        throw new Error('SharedService already loaded...');
      }
      console.info('SharedService created...');

      this.init();

      this.latitudeActive = 0;
      this.longitudeActive = 0;
      this.conversations = [];
      this.conversationHubBadgeCount = 0;
      this.activityHubTabBadgeCount = 0;
      this.establishNetworkMonitor();

      //TEMP:
/*
      let apptResult = {
        appointment_id: '1',
        client_id: '1',
        type: 1,
        presenting_complaint: 'Vomiting',
        occurred_before: '0',
        active_treatment: '0',
        veterinarian: {
          entity_id: null,
          name: 'Alexandra Parry'
        },
        start_time: Date.now(),
        end_time: Date.now() + 15*60*1000,
        description: null,
        status_type_id: 3, //1 = requested; 2 = accepted/pending client confirmation; 3 = confirmed; 4 = awaiting completion from vet; 5 = completed; 6 = cancelled
        media: [
          {
            type: 1,
            storage_uri: './assets/img/157869518.jpeg'
          },
          {
            type: 1,
            storage_uri: './assets/img/150340640.jpeg'
          }
        ],
        pet: {
          pet_id: '1',
          name: 'Simcoe',
          species: 'Feline',
          sex: 'Male',
          breed: 'Domestic Short Haired',
          status: 'Neutered',
          date_of_birth: '388000449983',
          media: {
            storage_uri: './assets/img/133883675.jpeg'
          },
          type: 1,
          medical_conditions: null,
          current_medications: null,
          relevant_medical_history: null,
          diet: null,
          primary_veterinarian: {
            clinic_id: null,
            name: "VCA O'Sullivan Animal Hospital",
            formatted_address: null,
            formatted_phone_number: null,
            email_address: null,
            data: null
          },
          vaccinations: [
            {
              vaccine: 'Rabies',
              date_given: '3880039399',
              date_valid_until: '885048383949'
            },
            {
              vaccine: 'FeLV',
              date_given: '45059850383',
              date_valid_until: '75948575759'
            }
          ]
        },
        medical_record: {
          status_type_id: 1, //0 = readonly; 1 = open
          vomiting: null,
          vomiting_details: null,
          diarrhea: null,
          diarrhea_details: null,
          coughing: null,
          coughing_details: null,
          sneezing: null,
          sneezing_details: null,
          pu: null,
          pu_details: null,
          pd: null,
          pd_details: null,
          inappetence: null,
          inappetence_details: null,
          lethargy: null,
          lethargy_details: null,
          lameness: null,
          lameness_details: null,
          pruritus: null,
          pruritus_details: null,
          other: null,
          other_details: null,
          photos: null,
          verbal_description: null,
          live_video_examination: null,
          mentation: null,
          bcs: null,
          eent: null,
          eent_details: null,
          skin: null,
          skin_details: null,
          cv: null,
          cv_details: null,
          dental: null,
          dental_details: null,
          abdomen: null,
          abdomen_details: null,
          ln: null,
          ln_details: null,
          ms: null,
          ms_details: null,
          respiratory: null,
          respiratory_details: null,
          genital: null,
          genital_details: null,
          neurologic: null,
          neurologic_details: null,
          assessment: null,
          ddx: null,
          proceed_to_er: null,
          start_tx: null,
          monitor: null,
          follow_up_asap: null,
          follow_up_no_improvement: null,
          discussed_virtual_pe_findings: null,
          discussed_ddx: null,
          discussed_recommendations: null,
          discussed_other: null,
          discussed_other_details: null,
          prescription_medication_given: false,
          prescription_medication_details: null,
          pharmacy: {
            name: null,
            formatted_address: null,
            formatted_phone_number: null,
            data: null
          },
          otc_medication_given: null,
          otc_medication_details: null,
          supportive_care_given: null,
          supportive_care_details: null,
          client_response: null,
          client_response_details: null,
          veterinarian_notes: null
        }
      };

      this.apptResultStack.push(apptResult);*/

      /*let petResult = {
        pet_id: '1',
        owner_id: '1',
        name: 'Simcoe',
        species: 'Feline',
        sex: 'Male',
        breed: 'Domestic Short Haired',
        status: 'Neutered',
        date_of_birth: '388000449983',
        media: {
          storage_uri: './assets/img/133883675.jpeg'
        },
        type: 1,
        medical_conditions: null,
        current_medications: null,
        relevant_medical_history: null,
        diet: null,
        primary_veterinarian: {
          clinic_id: null,
          name: "VCA O'Sullivan Animal Hospital",
          formatted_address: null,
          formatted_phone_number: null,
          email_address: null,
          data: null
        },
        vaccinations: [
          {
            vaccine: 'Rabies',
            date_given: '3880039399',
            date_valid_until: '885048383949'
          },
          {
            vaccine: 'FeLV',
            date_given: '45059850383',
            date_valid_until: '75948575759'
          }
        ]
      }
*/
      //this.petResultStack.push(petResult);

      /*this.presentingComplaintStack.push('Vomiting');
      this.presentingComplaintStack.push('Other');*/

      //TEMP END

    }

    async init() {
      await this.storage.create();
    }

    presentInAppNotification(image, text, duration) {
      this.inAppNotificationText = text;
      this.showInAppNotification = true;
      setTimeout(() => {
        this.closeInAppNotification();
      },duration);
    }

    closeInAppNotification() {
      console.log('closing InAppNotification...');
      this.showInAppNotification = false;
      setTimeout(() => {
        this.inAppNotificationText = '';
      },500);
    }


    setConnection(connection) {
      this.connection = connection;
    }

    setPlaces(places) {
      this.places = places;
    }

    setDomSanitizer(domSanitizer) {
      this.domSanitizer = domSanitizer;
    }

    setPlatform(platform) {
      this.platform = platform;
      if(this.platform.is('ios'))
        this.platformName = 'ios';
      else if (this.platform.is('android'))
        this.platformName = 'android';
      else if (this.platform.is('desktop'))
        this.platformName = 'desktop';
    }
    getPlatform() {
      return this.platform;
    }

    async displayAcknowledgementIonAlert(message) {
      const ionAlert = await this.alertController.create({
        cssClass: 'my-custom-class',
        header: '',
        subHeader: '',
        message: message,
        buttons: [
          {
            text: 'Ok',
            handler: () => {

            }
          }
        ]
      });

      await ionAlert.present();
    }

    async displayPushIonAlert(notification) {

      if(notification.notification.data.appointment_id) {
        const ionAlert = await this.alertController.create({
          cssClass: 'my-custom-class',
          header: '',
          subHeader: '',
          message: notification.notification.body,
          buttons: [
            {
              text: 'Appointment',
              handler: () => {
                this.apptResultStack.forEach(appointment => {
                  if(appointment.appointment_id == notification.notification.data.appointment_id) {
                    this.navigateToAppointmentPage(appointment);
                    return;
                  }
                });
              }
            },
            {
              text: 'Ok',
              handler: () => {

              }
            }]
        });

        await ionAlert.present();

      }
    }

    openMap(lat,lng,label,query) {

      if(!this.isApp()) {
        if(query != null) {
          this.openLinkInSystemBrowser('https://www.google.com/maps/search/' + query + '/@'+ lat + ',' + lng);
        } else {
          this.openLinkInSystemBrowser('https://www.google.com/maps/search/' + lat + ',' + lng + '/@'+ lat + ',' + lng);
        }


      } else {
        if (this.platform.is('ios')) {
          //try google maps first
          //alert('lat,lng='+lat+','+lng);
          //alert('comgooglemaps://?q=' + query + '&center=' + lat + ',' + lng);
          this.launchNavigator.isAppAvailable(this.launchNavigator.APP.GOOGLE_MAPS).then(
            response => {
              if(response) {
                if(query != null) {
                  this.openLinkInSystemBrowser('comgooglemaps://?q=' + query + '&center=' + lat + ',' + lng);
                } else {
                  if(label != null) {
                    this.openLinkInSystemBrowser('comgooglemaps://?q=' + lat + ',' + lng + '(' + label + ')');
                  } else {
                    this.openLinkInSystemBrowser('comgooglemaps://?q=' + lat + ',' + lng);
                  }

                }

                //window.open('comgooglemaps://?q=' + lat + ',' + lng + '(' + marker_name + ')', '_system');
              }
              else {
                if(query != null) {
                  this.openLinkInSystemBrowser('maps://?q=' + query);
                } else {
                  this.openLinkInSystemBrowser('maps://?q=' + lat + ',' + lng);
                }

              }
            },
            failure => {
              //check failed;
            }
          );
        } else if (this.platform.is('android')) {
          if(query != null) {
            this.openLinkInSystemBrowser('geo://' + lat + ',' + lng + '?q=' + query);
            //this.currentLocation.coords.latitude
            //this.currentLocation.coords.longitude
          } else {
            this.openLinkInSystemBrowser('geo://' + lat + ',' + lng + '?q=' + lat + ',' + lng);
          }

          //this.openLinkInSystemBrowser('geo://' + lat + ',' + lng + '?q=' + lat + ',' + lng + '(' + marker_name + ')', '_system');
        }
      }

    }

    updateLocation() {
      this.getStorageItem('location', (data, component) => {
        //alert(data);

        data = JSON.parse(data);

        if(data == null || !data.coords) {
          data = this.currentLocation;
        }

        if(data != null && data.coords) {
          component.places.getDetailsByCoords(data.coords.latitude + "," + data.coords.longitude, function(response, component){
            console.log('Retrieved place details...' + JSON.stringify(response.results[0]));

            //alert(JSON.stringify(response.results[0]));
            /*var data = JSON.parse(response.data).results[1];

            alert(JSON.stringify(data));*/

            //component.appointment.medical_record.pharmacy.data = component.appointment.medical_record.pharmacy.data.result;

            component.connection.requestHttpPostCapacitor(component.connection.generateRequestUrl('/update_location'),
            {
              auth_user_id: component.currentUser.user_id,
              remember_token: component.currentUser.remember_token,
              place_data: response.results[0]
            }, function(response, component) {

                //alert(JSON.stringify(response.message));

                var data = JSON.parse(response.data);

                if(data.code == 200){
                  console.log('Location updated.');
                  console.log(response);

                  //component.pricing = data.pricing;
                  //component.setItem('pricing', component.pricing);

                } else {
                  //show error notification
                  console.log(response);


                }
              }, function(err, component) {
                //alert(JSON.stringify(err));
                console.error('Error updating location... ' + JSON.stringify(err));


              }, component);

          }, function(response, component) {
            console.error('Error retrieving place details... ' + JSON.stringify(response));
            //alert(JSON.stringify(response));

          }, component);

        } else {
          console.log('Error updating location...');
        }

      },
      (error, component) => {
        //alert('error getting storage item: ' + error);
        console.error('Error getting Storage Item... ' + JSON.stringify(error));

      }, this);

    }

    hideTabs() {
      document.body.classList.add('tabs-hidden');
    }

    showTabs() {
      document.body.classList.remove('tabs-hidden');
    }

    setLocalStorage(variable,value) {
      window.localStorage.setItem(variable,value);
    }

    getLocalStorage(variable) {
      return window.localStorage.getItem(variable);
    }

    removeLocalStorage(variable) {
      return window.localStorage.removeItem(variable);
    }

    async presentToast(text,position,duration,cssClass) {
        let toast = await this.toastCtrl.create({
            message: text,
            duration: duration,
            position: position,
            cssClass: cssClass
        });
        await toast.present();
    }

    loadCurrentUser() {
      let params = {
        authEntityId: this.currentUserId,
        rememberToken: this.rememberToken,
        userEntityId: this.currentUserId
      };

     return new Promise<void>((resolve, reject) => {
        this.connection.requestHttpPost('/user-load', params, function(response, component){

          console.log(response.message);

          if(response.code == 200){
            //alert(JSON.stringify(response[0]));
            component.currentUser = response.data;
            resolve();
          } else {
            //show error notification
            reject();
          }
        }, function(err, component){
            console.log('\n' + err);
            reject();
        }, this);
      });
    }

    updateDeviceToken(oldToken,newToken) {

      this.connection.requestHttpPostCapacitor(this.connection.generateRequestUrl('/update_device_token'),
      {
        auth_user_id: this.currentUser.user_id,
        remember_token: this.currentUser.remember_token,
        device: {
          old_token: oldToken,
          new_token: newToken,
          platform: this.platformName,
          version: this.setup.version
        }
      }, function(response, component) {

          //alert(JSON.stringify(response.message));

          var data = JSON.parse(response.data);

          if(data.code == 200){
            console.log('Device token updated.');
            console.log(response);

            //component.pricing = data.pricing;
            //component.setItem('pricing', component.pricing);

          } else {
            //show error notification
            console.log(response);

          }
        }, function(err, component) {
          //alert(JSON.stringify(err));
          console.error('Error updating device token... ' + JSON.stringify(err));

        }, this);
    }

    updateDeviceApplicationVersion() {

      this.connection.requestHttpPostCapacitor(this.connection.generateRequestUrl('/update_device_application_version'),
      {
        auth_user_id: this.currentUser.user_id,
        remember_token: this.currentUser.remember_token,
        device: {
          token: this.currentUser.device.token,
          version: this.setup.version
        }
      }, function(response, component) {

          //alert(JSON.stringify(response.message));

          var data = JSON.parse(response.data);

          if(data.code == 200){
            console.log('Device application version updated.');
            console.log(response);

            //component.pricing = data.pricing;
            //component.setItem('pricing', component.pricing);

          } else if(data.code == 501) {
            component.displayAcknowledgementIonAlert(data.message);
            component.applicationUpdateRequired = true;
            //component.sharedService.presentToast(data.message, 'middle', 3000, 'toast');
          } else {
            //show error notification
            console.log(response);

          }
        }, function(err, component) {
          //alert(JSON.stringify(err));
          console.error('Error updating device application version... ' + JSON.stringify(err));

        }, this);
    }

    establishNetworkMonitor() {
      // watch network for a disconnect
      let disconnectSubscription = this.network.onDisconnect().subscribe(() => {
        console.log('network was disconnected :-(');
        this.networkActive = false;
        setTimeout(() => {
          this.zone.run(() => {
            setTimeout(() => {

            });
          });
        });
      });

      // stop disconnect watch
      //disconnectSubscription.unsubscribe();


      // watch network for a connection
      let connectSubscription = this.network.onConnect().subscribe(() => {
        console.log('network connected!');
        this.networkActive = true;


        // We just got a connection but we need to wait briefly
         // before we determine the connection type. Might need to wait.
        // prior to doing any api requests as well.
        /*setTimeout(() => {
          if (this.network.type === 'wifi') {
            console.log('we got a wifi connection, woohoo!');
          }
          setTimeout(() => {
            this.zone.run(() => {
              setTimeout(() => {
                let view = this.app.getActiveNav().getActive();
                view.component.content.resize();
              });
            });
          });
        }, 3000);*/
      });
    }

    getCurrentDateTime() {
      return Date.now();
    }

    convertToDateTimeString(dateTime) {
      //alert(dateTime);
      var tempDate = new Date(Number(dateTime));
      var dateTimeString =  new Date(Date.UTC(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate(), tempDate.getHours(), tempDate.getMinutes(), tempDate.getSeconds(), tempDate.getMilliseconds())).toISOString();
      return dateTimeString;
    }

    convertToTime(dateTimeString) {
      var date = new Date(dateTimeString);
      return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds()).getTime()
    }

    //NAVIGATION

    navigateToUserProfilePage(userProfile) {
      //alert(JSON.stringify(petProfile));
      if(this.currentUser.profile != null) {
        if(this.currentUser.profile.demo == 1) {
          this.displayAcknowledgementIonAlert('Editing Profile not permitted in demo environment.');
        } else {
          this.router.navigate(['/manageUserProfilePage'], {state: {userProfile: JSON.stringify(userProfile)}});
        }
      } else {
        this.router.navigate(['/manageUserProfilePage'], {state: {userProfile: JSON.stringify(userProfile)}});
      }

    }

    navigateToAppointmentPage(appointment) {
      //alert(JSON.stringify(petProfile));
      this.router.navigate(['/appointmentPage'], {state: {appointment: JSON.stringify(appointment)}});
    }

    navigateToPetProfilePage(petProfile) {
      //alert(JSON.stringify(petProfile));
      this.router.navigate(['/managePetProfilePage'], {state: {petProfile: JSON.stringify(petProfile)}});
    }

    navigateToExamRoomPage(event, appointment) {
      if(event) {
        event.stopPropagation();
        event.preventDefault();
      }

      this.router.navigate(['/examRoomPage'], {state: {appointment: JSON.stringify(appointment)}});
    }

    navigateToPayPalPaymentPage(appointment) {
      //alert(JSON.stringify(petProfile));
      this.router.navigate(['/payPalPaymentPage'], {state: {appointment: JSON.stringify(appointment)}});
    }

    navigateToChangePasswordPage() {
      //alert(JSON.stringify(petProfile));
      if(this.currentUser.profile != null) {
        if(this.currentUser.profile.demo == 1) {
          this.displayAcknowledgementIonAlert('Changing password not permitted in demo environment.');
        } else {
          this.router.navigate(['/changePasswordPage'], {state: {}});
        }

      } else {
        this.router.navigate(['/changePasswordPage'], {state: {}});
      }

    }

    //NAVIGATION - END

    toggleUserType() {
      if(this.currentUser.type_id == 1) {
        this.currentUser.type_id = 2;
      } else {
        this.currentUser.type_id = 1;
      }
    }

    //PAYMENTS - START

    /*payWithStripe() {
      this.stripe.setPublishableKey('pk_test_51JIH37JfSkdfWlbrMR96tNIBSfSpGNRvCmNCcrdhhSxlBCntzlPumQKsdTIvKDctn0yg6tcLnsITl2KZqXQ1kPUh00pyCWLSJZ');

      let card = {
       number: '4242424242424242',
       expMonth: 12,
       expYear: 2020,
       cvc: '220'
      };

      this.stripe.getCardType(card.number)
        .then(cardType => console.log(cardType))
        .catch(error => console.error(error));

      this.stripe.createCardToken(card)
         .then(token => console.log(token.id))
         .catch(error => console.error(error));

      //validate credit card


    }*/

    payWithPayPal() {

    }

    //PAYMENTS - END

    //STORAGE START

    /*setStorageItem(key, value) {
      //alert(JSON.stringify(value));
      this.nativeStorage.setItem(key, value)
        .then(
          () => {
            //alert('storedItem');
            console.log('Stored item!')
          },
          (error) => {
            //alert(JSON.stringify(error));
            console.error('Error storing item', error);
          }
        );
    }

    getStorageItem(key, successFn, errorFn, component) {
      this.nativeStorage.getItem(key)
        .then(
          (data) => {
            successFn(data, component);
          },
          (error) => {
            errorFn(error, component);
          }
        );
    }*/

    setStorageItem(key, value) {
      //alert(JSON.stringify(value));
      this.storage.set(key, value)
        .then(
          () => {
            //alert('storedItem');
            console.log('Stored item!')
          },
          (error) => {
            //alert(JSON.stringify(error));
            console.error('Error storing item', error);
          }
        );
    }

    setStorageItemThen(key, value, successFn) {
      //alert(JSON.stringify(value));
      this.storage.set(key, value)
        .then(
          () => {
            //alert('storedItem');
            successFn();
            console.log('Stored item!')
          },
          (error) => {
            //alert(JSON.stringify(error));
            console.error('Error storing item', error);
          }
        );
    }

    getStorageItem(key, successFn, errorFn, component) {
      this.storage.get(key)
        .then(
          (data) => {
            successFn(data, component);
          },
          (error) => {
            errorFn(error, component);
          }
        );
    }

    //STORAGE END


    //MISC START

    validateEmail(email) {
     const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
     return regularExpression.test(String(email).toLowerCase());
    }

    validatePhoneNumber(phoneNumber) {
     const regularExpression = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
     return regularExpression.test(String(phoneNumber));
    }

    openLinkInSystemBrowser(link) {
      //await Browser.open({ url: link, windowName: '_system' });
      const browser = this.inAppBrowser.create(link,'_system');

      //cordova.InAppBrowser.open(link,'_system','location=yes');
    }


    //MISC END

    //RATING - START

    async showRatingModal(appointment) {

      const modal = await this.modalController.create({
        component: RatingPage,
        swipeToClose: true,
        presentingElement: this.routerOutlet.nativeEl,
        componentProps: {
          'appointment': appointment
        }
        //cssClass: 'my-custom-class'
      });

      await modal.present();

      const{data} = await modal.onDidDismiss();

      /*if(data.transaction.status == 'COMPLETED') {
        this.appointment.status_type_id = '1';
        this.mode = 'view';
      }*/
    }

    //RATING - END

    //VET PROFILE PAGE - START

    async showVetProfileModal(event, profile) {

      event.stopPropagation();

      const modal = await this.modalController.create({
        component: VetProfilePage,
        swipeToClose: true,
        presentingElement: this.routerOutlet.nativeEl,
        componentProps: {
          'profile': profile
        }
        //cssClass: 'my-custom-class'
      });

      await modal.present();

      const{data} = await modal.onDidDismiss();

      /*if(data.transaction.status == 'COMPLETED') {
        this.appointment.status_type_id = '1';
        this.mode = 'view';
      }*/
    }

    //VET PROFILE PAGE - END

    //PRICING

    getPricing(petId, typeId) {
      this.getStorageItem('location', (data, component) => {

        data = JSON.parse(data);

        component.places.getDetailsByCoords(data.coords.latitude + "," + data.coords.longitude, function(response, component){
          console.log('Retrieved place details...' + JSON.stringify(response.results[0]));

          /*var data = JSON.parse(response.data).results[1];

          alert(JSON.stringify(data));*/

          //component.appointment.medical_record.pharmacy.data = component.appointment.medical_record.pharmacy.data.result;

          component.connection.requestHttpPostCapacitor(component.connection.generateRequestUrl('/get_pricing'),
          {
            auth_user_id: component.currentUser.user_id,
            remember_token: component.currentUser.remember_token,
            place_data: response.results[0],
            pet_id: petId,
            type_id: typeId
          }, function(response, component) {

              //alert(JSON.stringify(response.message));

              var data = JSON.parse(response.data);

              if(data.code == 200){
                console.log('Pricing retrieved.');
                console.log(response);

                return data.pricing;

                //component.pricing = data.pricing;
                //component.setItem('pricing', component.pricing);

              } else {
                //show error notification
                console.log(response);
                return null;

              }
            }, function(err, component) {
              //alert(JSON.stringify(err));
              console.error('Error retrieving pricing... ' + JSON.stringify(err));
              return null;

            }, component);

        }, function(response, component) {
          console.error('Error retrieving place details... ' + JSON.stringify(response));
          //alert(JSON.stringify(response));
          return null;

        }, component);

      },
      (error, component) => {
        //alert('error getting storage item: ' + error);
        console.error('Error getting Storage Item... ' + JSON.stringify(error));
        return null;
      }, this);

    }

    //PRICING END

    async authenticate() {

      let promise = new Promise((resolve, reject) => {

        if(this.currentUser.user_id == null || this.currentUser.remember_token == null) {
          this.navController.navigateRoot('/landingPage').then(() => {
            return resolve;
          });
        }

        this.connection.requestHttpPostCapacitor(this.connection.generateRequestUrl('/authenticate'),
        {
          auth_user_id: this.currentUser.user_id,
          remember_token: this.currentUser.remember_token
        }, function(response, component) {

          //alert(JSON.stringify(response.message));

          var data = JSON.parse(response.data);

          if(data.code == 200){
            console.log('Authentication check completed.');
            console.log(response);

            if(data.authenticated == 1) {

              component.currentUser.url_signature = data.url_signature;
              return resolve;
            } else {
              console.log('Could not authenticate...');

              component.navController.navigateRoot('/landingPage').then(() => {
                return resolve;
              });
            }

          } else {
            //show error notification
            console.log(response);
            return reject;
          }

        }, function(err, component) {
          //alert(JSON.stringify(err));
          console.error('Error authenticating... ' + JSON.stringify(err));
          return resolve;
        }, this);
      });
    }

    //STARTUP DATA - START

    getUserStartupData() {

      this.getStorageItem('current_user', (data, component) => {

        if(!data) {
          console.log('currentUser username or remember_token are null...');

          component.navController.navigateRoot('/landingPage').then(() => {
            SplashScreen.hide();
          });
        } else {

          if(!data.username || !data.remember_token) {
            console.log('currentUser username or remember_token are null...');

            component.navController.navigateRoot('/landingPage').then(() => {
              SplashScreen.hide();
            });
          }

          component.currentUser = data;

          //alert(JSON.stringify(data));

          //START - AUTHENTICATE

          component.connection.requestHttpPostCapacitor(component.connection.generateRequestUrl('/authenticate'),
          {
            auth_user_id: component.currentUser.user_id,
            remember_token: component.currentUser.remember_token
          }, function(response, component) {

            //alert(JSON.stringify(response.message));

            var data = JSON.parse(response.data);

            if(data.code == 200){
              console.log('Authentication check completed.');
              console.log(response);

              if(data.authenticated == 1) {

                component.getTURNServerDetails();

                component.currentUser.url_signature = data.url_signature;

                component.getStorageItem('settings', (data, component) => {
                  component.settings = data;
                  //alert('got storage item: ' + component.presets);
                },
                (error, component) => {
                  //alert('error getting storage item: ' + error);
                  console.error('Error getting Storage Item... ' + error);
                }, component);

                component.getStorageItem('my_pets', (data, component) => {
                  component.petResultStack = data;
                },
                (error, component) => {
                  console.error('Error retrieving my pets from storage... ' + JSON.stringify(error));
                }, component);

                component.getStorageItem('appointments', (data, component) => {
                  component.apptResultStack = data;
                },
                (error, component) => {
                  console.error('Error retrieving appointments from storage... ' + JSON.stringify(error));
                }, component);

                component.getStorageItem('triage_queue_appointments', (data, component) => {
                  component.triageQueueApptResultStack = data;
                },
                (error, component) => {
                  console.error('Error retrieving triage queue appointments from storage... ' + JSON.stringify(error));
                }, component);

                //alert(this.currentUser);

                //this.currentUser.profile = this.loadUser(this.currentUser.user_id);

                component.updateLocation();
                component.markAllPushAsSeen();

                //START - UPDATE CURRENT USER DATA

                let params = {
                  auth_user_id: component.currentUser.user_id,
                  remember_token: component.currentUser.remember_token,
                  user_id: component.currentUser.user_id
                };

                component.connection.requestHttpPostCapacitor(component.connection.generateRequestUrl('/get_user_by_id'), params, function(response, component) {

                  //alert(JSON.stringify(response.message));

                  var data = JSON.parse(response.data);

                  if(data.code == 200){
                    console.log('Current user profile retrieved.');
                    console.log(response);
                    //alert(JSON.stringify(response));

                    component.currentUser.profile = data.user;

                    component.updateDeviceApplicationVersion();
                    component.startTriageQueueCheck();

                    SplashScreen.hide();
                  } else {
                    //show error notification
                    console.log(response);
                    SplashScreen.hide();
                  }
                }, function(err, component) {
                  //alert(JSON.stringify(err));
                  console.error('Error retrieving current user profile... ' + JSON.stringify(err));
                  SplashScreen.hide();
                }, component);

                //END - UPDATE CURRENT USER DATA

                //START - UPDATE SETTINGS

                component.connection.requestHttpPostCapacitor(component.connection.generateRequestUrl('/get_settings_by_user_id'),
                {
                  auth_user_id: component.currentUser.user_id,
                  remember_token: component.currentUser.remember_token
                }, function(response, component) {

                  //alert(JSON.stringify(response.message));

                  var data = JSON.parse(response.data);

                  if(data.code == 200){
                    console.log('Settings retrieved.');
                    console.log(response);

                    component.settings = data.settings;
                    component.setStorageItem('settings', component.settings);


                  } else {
                    //show error notification
                    console.log(response);

                  }
                }, function(err, component) {
                  //alert(JSON.stringify(err));
                  console.error('Error retrieving settings... ' + JSON.stringify(err));

                }, component);

                //END - UPDATE SETTINGS

                //START - LOAD MY PETS

                component.connection.requestHttpPostCapacitor(component.connection.generateRequestUrl('/get_pets_by_owner_id'),
                {
                  auth_user_id: component.currentUser.user_id,
                  remember_token: component.currentUser.remember_token,
                  owner_id: component.currentUser.user_id,
                  offset: 0,
                  limit: 50
                }, function(response, component) {

                  //alert(JSON.stringify(response.message));

                  var data = JSON.parse(response.data);

                  if(data.code == 200){
                    console.log('Pets by owner ID retrieved.');
                    console.log(response);

                    component.petResultStack = data.pets;
                    component.setStorageItem('my_pets', component.petResultStack);

                  } else {
                    //show error notification
                    console.log(response);
                  }
                }, function(err, component) {
                  //alert(JSON.stringify(err));
                  console.error('Error retrieving my pets... ' + JSON.stringify(err));

                }, component);

                //END - LOAD MY PETS

                //START - LOAD APPOINTMENTS

                component.connection.requestHttpPostCapacitor(component.connection.generateRequestUrl('/get_appointments'),
                {
                  auth_user_id: component.currentUser.user_id,
                  remember_token: component.currentUser.remember_token,
                  offset: 0,
                  limit: 50
                }, function(response, component) {

                  //alert(JSON.stringify(response.message));

                  var data = JSON.parse(response.data);

                  if(data.code == 200){
                    console.log('Appointments retrieved.');
                    console.log(response);

                    component.apptResultStack = data.appointments;
                    component.setStorageItem('appointments', component.apptResultStack);

                  } else {
                    //show error notification
                    console.log(response);
                  }
                }, function(err, component) {
                  //alert(JSON.stringify(err));
                  console.error('Error retrieving appointments... ' + JSON.stringify(err));

                }, component);

                //END - LOAD APPOINTMENTS

                if(component.currentUser.profile.type_id == 1) {
                  //START - LOAD TRIAGE QUEUE APPOINTMENTS

                  component.connection.requestHttpPostCapacitor(component.connection.generateRequestUrl('/get_triage_queue_appointments'),
                  {
                    auth_user_id: component.currentUser.user_id,
                    remember_token: component.currentUser.remember_token,
                    offset: 0,
                    limit: 50
                  }, function(response, component) {

                    //alert(JSON.stringify(response.message));

                    var data = JSON.parse(response.data);

                    if(data.code == 200){
                      console.log('Triage Queue appointments retrieved.');
                      console.log(response);

                      component.triageQueueApptResultStack = data.appointments;
                      if(data.appointments.length <= 0) {
                        component.showAppointmentBadge = false;
                      } else {
                        component.showAppointmentBadge = true;

                        if(data.appointments.length > 0 && data.appointments.length < 10) {
                          component.appointmentBadgeCount = data.appointments.length;
                        } else {
                          component.appointmentBadgeCount = '10+';
                        }

                      }
                      component.setStorageItem('triage_queue_appointments', component.triageQueueApptResultStack);

                    } else {
                      //show error notification
                      console.log(response);
                    }
                  }, function(err, component) {
                    //alert(JSON.stringify(err));
                    console.error('Error retrieving triage queue appointments... ' + JSON.stringify(err));

                  }, component);

                  //END - LOAD TRIAGE QUEUE APPOINTMENTS
                }

                //START - LOAD PAST APPOINTMENTS

                component.connection.requestHttpPostCapacitor(component.connection.generateRequestUrl('/get_past_appointments'),
                {
                  auth_user_id: component.currentUser.user_id,
                  remember_token: component.currentUser.remember_token,
                  offset: 0,
                  limit: 50
                }, function(response, component) {

                  //alert(JSON.stringify(response.message));

                  var data = JSON.parse(response.data);

                  if(data.code == 200){
                    console.log('Past appointments retrieved.');
                    console.log(response);

                    component.pastApptResultStack = data.appointments;
                    component.setStorageItem('past_appointments', component.pastApptResultStack);

                  } else {
                    //show error notification
                    console.log(response);
                  }
                }, function(err, component) {
                  //alert(JSON.stringify(err));
                  console.error('Error retrieving past appointments... ' + err);

                }, component);

                //END - LOAD PAST APPOINTMENTS
              } else {
                //console.log('Could not authenticate...');

                component.navController.navigateRoot('/landingPage').then(() => {
                  SplashScreen.hide();
                });
              }

            } else {
              //show error notification
              console.log(response);
            }
          }, function(err, component) {
            //alert(JSON.stringify(err));
            console.error('Error authenticating... ' + JSON.stringify(err));

          }, component);

          //END - AUTHENTICATE

        }
      },
      (error, component) => {
        //alert(JSON.stringify(error));
        component.navController.navigateRoot('/landingPage').then(() => {
          SplashScreen.hide();
        });
        //this.rootPage = 'LoginPage';
        console.error('Error getting StorageItem...' + error);
      }, this);
    }

    //STARTUP DATA - END

    //PRESETS - START

    getPresets() {
      this.getStorageItem('presets', (data, component) => {
        component.presets = data;
        //alert('got storage item: ' + component.presets);
      },
      (error, component) => {
        //alert('error getting storage item: ' + error);
        console.error('Error getting Storage Item... ' + error);
      }, this);

      this.connection.requestHttpPostCapacitor(this.connection.generateRequestUrl('/get_presets'), {}, function(response, component) {
        //alert('ok ' + JSON.stringify(response.message));

        //response = JSON.parse(JSON.stringify(JSON.parse(response)));

        if(response.status == 200){

          console.log(response);

          var data = JSON.parse(response.data);

          component.presets = data.presets;
          component.setStorageItem('presets', data.presets);

          //alert('sharedService.presets: ' + component.presets);

        } else {
          //show error notification
          //alert('error storing presets: ' + JSON.stringify(response));
          console.log(response);
        }
      }, function(err, component) {
        //alert('error getting presets:' + JSON.stringify(err));
        console.error('Error getting presets... ' + JSON.stringify(err));
      }, this);

    }

    //PRESETS - END

    async markAllPushAsSeen() {

      let promise = new Promise((resolve, reject) => {

          this.connection.requestHttpPostCapacitor(this.connection.generateRequestUrl('/mark_all_push_notifications_as_seen'),
          {
            auth_user_id: this.currentUser.user_id,
            remember_token: this.currentUser.remember_token,
          }, function(response, component) {

            //alert(JSON.stringify(response.message));

            var data = JSON.parse(response.data);

            if(data.code == 200){
              console.log('Push notifications marked as seen.');

              console.log(response);

            } else {
              //show error notification
              console.log(response);
            }
            return resolve;

          }, function(err, component) {
            //alert(JSON.stringify(err));
            console.error('Error marking push notifications as seen... ' + JSON.stringify(err));
            return reject;
          }, this);


      });

    }

    isApp() {
      return Capacitor.isNativePlatform();
    }



    async refreshData() {

      let promise = new Promise((resolve, reject) => {
        //TODO
        var limit = 0;

        if(this.apptResultStackOffset == 0) {
          limit = this.apptResultStackLimit;
        } else {
          limit = this.apptResultStackOffset;
        }

        //START - LOAD APPOINTMENTS
          this.connection.requestHttpPostCapacitor(this.connection.generateRequestUrl('/get_appointments'),
          {
            auth_user_id: this.currentUser.user_id,
            remember_token: this.currentUser.remember_token,
            offset: 0,
            limit: limit
          }, function(response, component) {

            //alert(JSON.stringify(response.message));

            var data = JSON.parse(response.data);

            if(data.code == 200){
              console.log('Appointments retrieved.');
              console.log(response);

              if(data.appointments.length <= 0) {
                component.apptResultStack = [];
              } else if (component.apptResultStack.length == 0) {
                component.apptResultStack = data.appointments;
              } else {

                for (var ctr = 0; ctr < component.apptResultStack.length; ctr++) {
                  var found = false;

                  for (var index = 0; index <= data.appointments.length; index++) {
                    if(component.apptResultStack[ctr].appointment_id == data.appointments[index].appointment_id) {
                      if(JSON.stringify(component.sharedService.apptResultStack[ctr]) != JSON.stringify(data.appointments[index])) {
                        component.sharedService.apptResultStack.splice(ctr, 1, data.appointments[index]);
                      }
                      found = true;
                      break;
                    }
                  }

                  if(!found) {
                    component.apptResultStack.splice(ctr, 1);
                  }

                }

                for (var ctr = 0; ctr < data.appointments.length; ctr++) {
                  var found = false;

                  for (var index = 0; index <= component.apptResultStack.length; index++) {
                    if(component.apptResultStack[index].appointment_id == data.appointments[ctr].appointment_id) {
                      found = true;
                      break;
                    }
                  }

                  if(!found) {
                    component.apptResultStack.push(data.appointments[ctr]);
                  }

                }
              }

              component.apptResultStackOffset = component.apptResultStack.length;
              component.setStorageItem('appointments', component.apptResultStack);

            } else {
              //show error notification
              console.log(response);
            }

          }, function(err, component) {
            //alert(JSON.stringify(err));
            console.error('Error retrieving appointments... ' + JSON.stringify(err));

          }, this);

          //END - LOAD APPOINTMENTS

          //START - LOAD TRIAGE QUEUE APPOINTMENTS

          if(this.triageQueueApptResultStackOffset == 0) {
            limit = this.triageQueueApptResultStackLimit;
          } else {
            limit = this.triageQueueApptResultStackOffset;
          }

          if(this.currentUser.type_id == 1) {
            this.connection.requestHttpPostCapacitor(this.connection.generateRequestUrl('/get_triage_queue_appointments'),
            {
              auth_user_id: this.currentUser.user_id,
              remember_token: this.currentUser.remember_token,
              offset: 0,
              limit: limit
            }, function(response, component) {

              //alert(JSON.stringify(response.message));

              var data = JSON.parse(response.data);

              if(data.code == 200){
                console.log('Triage queue appointments retrieved.');
                console.log(response);

                if(data.appointments.length <= 0) {
                  component.triageQueueApptResultStack = [];
                } else if (component.triageQueueApptResultStack.length == 0) {
                  component.triageQueueApptResultStack = data.appointments;
                } else {

                  for (var ctr = 0; ctr < component.triageQueueApptResultStack.length; ctr++) {
                    var found = false;

                    for (var index = 0; index <= data.appointments.length; index++) {
                      if(component.triageQueueApptResultStack[ctr].appointment_id == data.appointments[index].appointment_id) {
                        if(JSON.stringify(component.sharedService.triageQueueApptResultStack[ctr]) != JSON.stringify(data.appointments[index])) {
                          component.sharedService.triageQueueApptResultStack.splice(ctr, 1, data.appointments[index]);
                        }
                        found = true;
                        break;
                      }
                    }

                    if(!found) {
                      component.triageQueueApptResultStack.splice(ctr, 1);
                    }

                  }

                  for (var ctr = 0; ctr < data.appointments.length; ctr++) {
                    var found = false;

                    for (var index = 0; index <= component.triageQueueApptResultStack.length; index++) {
                      if(component.triageQueueApptResultStack[index].appointment_id == data.appointments[ctr].appointment_id) {
                        found = true;
                        break;
                      }
                    }

                    if(!found) {
                      component.triageQueueApptResultStack.push(data.appointments[ctr]);
                    }

                  }
                }

                component.triageQueueApptResultStackOffset = component.triageQueueApptResultStack.length;
                component.setStorageItem('triage_queue_appointments', component.triageQueueApptResultStack);

              } else {
                //show error notification
                console.log(response);
              }

              if((component.triageQueueApptResultStack.length < component.triageQueueApptResultStackLimit) && (component.currentUser.type_id == 1)) {
                component.infiniteScroll.disabled = true;
              } else if((component.pastApptResultStack.length < component.pastApptResultStackLimit) && (component.currentUser.type_id == 2)) {
                component.infiniteScroll.disabled = true;
              } else {
                component.infiniteScroll.disabled = false;
              }

            }, function(err, component) {
              //alert(JSON.stringify(err));
              console.error('Error retrieving triage queue appointments... ' + JSON.stringify(err));
            }, this);
          }

          //END - LOAD TRIAGE QUEUE APPOTINMENTS

          //START - LOAD PAST APPOINTMENTS

          if(this.pastApptResultStackOffset == 0) {
            limit = this.pastApptResultStackLimit;
          } else {
            limit = this.pastApptResultStackOffset;
          }

          if(this.currentUser.type_id == 2) {
            this.connection.requestHttpPostCapacitor(this.connection.generateRequestUrl('/get_past_appointments'),
            {
              auth_user_id: this.currentUser.user_id,
              remember_token: this.currentUser.remember_token,
              query: this.appointmentsPastAppointmentSearchText,
              offset: 0,
              limit: limit
            }, function(response, component) {

              //alert(JSON.stringify(response.message));

              var data = JSON.parse(response.data);

              if(data.code == 200){
                console.log('Past appointments retrieved.');
                console.log(response);

                if(data.appointments.length <= 0) {
                  component.pastApptResultStack = [];
                } else if (component.pastApptResultStack.length == 0) {
                  component.pastApptResultStack = data.appointments;
                } else {

                  for (var ctr = 0; ctr < component.pastApptResultStack.length; ctr++) {
                    var found = false;

                    for (var index = 0; index <= data.appointments.length; index++) {
                      if(component.pastApptResultStack[ctr].appointment_id == data.appointments[index].appointment_id) {
                        if(JSON.stringify(component.sharedService.pastApptResultStack[ctr]) != JSON.stringify(data.appointments[index])) {
                          component.sharedService.pastApptResultStack.splice(ctr, 1, data.appointments[index]);
                        }
                        found = true;
                        break;
                      }
                    }

                    if(!found) {
                      component.pastApptResultStack.splice(ctr, 1);
                    }

                  }

                  for (var ctr = 0; ctr < data.appointments.length; ctr++) {
                    var found = false;

                    for (var index = 0; index <= component.pastApptResultStack.length; index++) {
                      if(component.pastApptResultStack[index].appointment_id == data.appointments[ctr].appointment_id) {
                        found = true;
                        break;
                      }
                    }

                    if(!found) {
                      component.pastApptResultStack.push(data.appointments[ctr]);
                    }

                  }

                }

                component.pastApptResultStackOffset = component.pastApptResultStack.length;
                component.setStorageItem('past_appointments', component.pastApptResultStack);

              } else {
                //show error notification
                console.log(response);
              }

            }, function(err, component) {
              //alert(JSON.stringify(err));
              console.error('Error retrieving past appointments... ' + JSON.stringify(err));
            }, this);
          }

          //END - LOAD PAST APPOINTMENTS

        /*setTimeout(() => {
          console.log('Done');
          event.target.complete();

          // App logic to determine if all data is loaded
          // and disable the infinite scroll

        }, 500);*/
      });
      return promise;


    }

    async call(name, number) {
      const ionAlert = await this.alertController.create({
        cssClass: 'my-custom-class',
        header: 'Call ' + name + '?',
        subHeader: '',
        message: number,
        buttons: [
          {
            text: 'Yes',
            handler: () => {
              this.callNumber.callNumber(number,true)
              .then(res => console.log('Launched dialer!', res))
              .catch(err => console.log('Error launching dialer', err));
            }
          },
          {
            text: 'No',
            handler: () => {

            }
          }
        ]
      });

      await ionAlert.present();
    }

    /*async checkAndRequestLocationPermissions() {
      let permissionStatus = await Geolocation.checkPermissions();
      //alert(JSON.stringify(permissionStatus));

      if(permissionStatus.location != 'granted' && permissionStatus.coarseLocation != 'granted') {
        Geolocation.requestPermissions({permissions:['location']});
      }
    }*/

    async getCurrentLocation() {

      return new Promise<any>((resolve) => {
        this.geolocation.getCurrentPosition().then((data) => {

         // resp.coords.latitude
         // resp.coords.longitude
         if('coords' in data) {
           //alert('got position');
           //alert(data.coords.latitude);
           this.setStorageItemThen('location', JSON.stringify(data), () => {
             this.updateLocation();
           });
           this.currentLocation = data;

           resolve(data);
         }
        }).catch((error) => {
          console.log('Error getting location', error);
          this.displayAcknowledgementIonAlert('Please enable Location Services.');
          resolve(null);
        });
      });
    }

    async getTURNServerDetails() {

      let params = {
        auth_user_id: this.currentUser.user_id,
        remember_token: this.currentUser.remember_token,
        user_id: this.currentUser.user_id
      };

      this.connection.requestHttpPostCapacitor(this.connection.generateRequestUrl('/get_turn_server_details'), params, function(response, component) {

        //alert(JSON.stringify(response.message));

        var data = JSON.parse(response.data);
        //alert(data.details);
        var details = JSON.parse(data.details);

        if(data.code == 200){
          console.log('Turn server details retrieved.');
          console.log(response);

          component.turnServerDetails = details;

        } else if(data.code == 501) {
          console.log(response);

        } else {
          //show error notification

          console.log(response);
        }
      }, function(err, component) {
        //alert(JSON.stringify(err));

        console.error('Error retrieving turn server details... ' + err);

      }, this);

    }

    async configureLocationServices() {


      //let permissionStatus = await Geolocation.checkPermissions();
      //alert(JSON.stringify(permissionStatus));

      /*if(permissionStatus.location != 'granted' && permissionStatus.coarseLocation != 'granted') {
        setTimeout(() => {
          this.checkAndRequestLocationPermissions();
        }, 10000);
      }*/

              //alert('getting current position');


              //let data = await Geolocation.getCurrentPosition({});
              this.geolocation.getCurrentPosition().then((data) => {

               // resp.coords.latitude
               // resp.coords.longitude
               if('coords' in data) {
                 //alert('got position');
                 //alert(data.coords.latitude);
                 this.setStorageItemThen('location', JSON.stringify(data), () => {
                   this.updateLocation();
                 });

                 this.currentLocation = data;
                 //appointment.currentLocation = data;

                 //appointment.getPricing();

                 //alert(JSON.stringify(this.currentLocation));

                 /*this.sharedService.getStorageItem('location', (data, component) => {
                   alert(JSON.stringify(data));
                 },
                 (error, component) => {
                   //alert(JSON.stringify(error));
                   console.error(error);
                 }, null);*/

               }
              }).catch((error) => {
                console.log('Error getting location', error);
                this.displayAcknowledgementIonAlert('Please enable Location Services in order to request an appointment.');
              });
              //alert(JSON.stringify(data));


              let watch = this.geolocation.watchPosition();
              watch.subscribe((data) => {
               // data can be a set of coordinates, or an error (if an error occurred).
               // data.coords.latitude
               // data.coords.longitude
               if('coords' in data) {
                 this.setStorageItem('location', JSON.stringify(data));
                 this.currentLocation = data;
               }
              });

              /*Geolocation.watchPosition({}, (data) => {

                //alert(JSON.stringify(data));
                if('coords' in data) {
                  this.setStorageItem('location', data);
                  this.currentLocation = data;


                  /*this.sharedService.getStorageItem('location', (data, component) => {
                    alert(JSON.stringify(data));
                  },
                  (error, component) => {
                    //alert(JSON.stringify(error));
                    console.error(error);
                  }, null);*/

                //}

               // data can be a set of coordinates, or an error (if an error occurred).
               // data.coords.latitude
               // data.coords.longitude
              //});


    }

    async startTriageQueueCheck() {
      if(this.currentUser.type_id == 1) {
        while(this.foreground) {
          if((this.activeTab == 'dashboard' || this.activeTab == 'settings')) {
            this.connection.requestHttpPostCapacitor(this.connection.generateRequestUrl('/get_triage_queue_appointments'),
            {
              auth_user_id: this.currentUser.user_id,
              remember_token: this.currentUser.remember_token,
              offset: 0,
              limit: 10
            }, function(response, component) {

              var data = JSON.parse(response.data);


              if(data.code == 200){
                console.log('Triage queue appointments retrieved.');
                console.log(response);

                if(data.appointments.length <= 0) {
                  component.showAppointmentBadge = false;
                } else {
                  component.showAppointmentBadge = true;

                  if(data.appointments.length > 0 && data.appointments.length < 10) {
                    component.appointmentBadgeCount = data.appointments.length;
                  } else {
                    component.appointmentBadgeCount = '10+';
                  }

                }


              } else {
                //show error notification
                console.log(response);
              }

            }, function(err, component) {
              //alert(JSON.stringify(err));
              console.error('Error retrieving triage queue appointments... ' + JSON.stringify(err));
            }, this);
          }

          await this.delay(5000);

        };
      }
    }

    async delay(ms: number) {
      await new Promise<void>(resolve => setTimeout(()=>resolve(), ms)).then(()=>console.log("delayed"));
    }

    boolifyPromise(promise) {
      return promise.then(() => true).catch(() => false);
    }



}
